import { AbstractTicketProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractTicketProperties";
import { GridLayout } from "@lib/titan2/dist/game/control/layout/GridLayout";
import { PanelProperties } from "@lib/titan2/dist/game/control/properties/PanelProperties";
import { deepEquals } from "../../../utils/deepEquals";
/**
 * Game-specific ticket properties.
 */
export class GameTicketProperties extends AbstractTicketProperties {
    constructor() {
        super();
        this.slingoInitialDelay = 300;
        this.patternWinInterval = 500;
        this.transitionRowInterval = 100;
        this.symbolPanelProperties = new PanelProperties();
        this.backgroundProperties = null;
        this.symbolPanelProperties.layout = new GridLayout(5, 5, 5, 5);
    }
    equals(other) {
        return deepEquals(other, this);
    }
}
//# sourceMappingURL=GameTicketProperties.js.map